/* Saint Véra: completa a última linha das grades para nunca sobrar buraco.
   - Coleção ([data-sv-grid]): faltam = (colunas - lugares usados % colunas) % colunas; 1 lugar = card simples,
     2-3 lugares = um card largo. Só na última página carregada (antes do "Carregar mais", 24 peças fecham a linha).
   - Vistos recentemente ([data-sv-more=rv]): é carrossel; completa só quando há menos peças que a faixa mostra
     (4 no computador, 3 no celular, onde aparecem 2,2).
   Acervo: <template id="sv-fill-pool"> (snippets/sv-grid-fill.liquid). Ordem determinística por página:
   primeiro os cards com prioridade para esta coleção, depois o resto girado por um hash do caminho. A grade usa o 1º
   da fila e os vistos usam os seguintes, então o mesmo card nunca aparece duas vezes. Nunca linka a página atual e
   pula o card cuja foto mostra uma peça que já está na grade/faixa ou é a peça da PDP (campo "Peça na foto"). */
(() => {
  const pool = document.getElementById('sv-fill-pool');
  if (!pool || window.__svFill) return;
  window.__svFill = 1;

  const desk = matchMedia('(min-width: 1000px)');
  const norm = (p) => p.replace(/\/+$/, '').toLowerCase() || '/';
  const here = norm(location.pathname);
  const coll = pool.dataset.coll || '';
  const prod = pool.dataset.prod || '';
  const hash = (s) => [...s].reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);
  const rot = (a, n) => (a.length ? a.slice(n % a.length).concat(a.slice(0, n % a.length)) : a);

  const all = [...pool.content.querySelectorAll('.sv-fill')].filter((a) => norm(new URL(a.getAttribute('href'), location.origin).pathname) !== here);
  const pri = coll ? all.filter((a) => a.dataset.pri.includes(',' + coll + ',')) : [];
  const h = hash(here);
  const queue = rot(pri, h).concat(rot(all.filter((a) => !pri.includes(a)), h));
  if (!queue.length) return;

  let css;
  const ready = () =>
    (css ||= new Promise((ok) => {
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = pool.dataset.css;
      l.onload = l.onerror = ok;
      document.head.appendChild(l);
    }));

  const make = (tag, cls, key, card) => {
    const el = document.createElement(tag);
    el.className = cls;
    el.dataset.svFill = key;
    el.appendChild(card.cloneNode(true));
    return el;
  };

  /* n cards da fila, sem os de `skip` e sem foto de peça já presente em `box`; se faltar, completa sem o filtro de peça */
  const pick = (box, skip, n) => {
    const hs = [...box.querySelectorAll('[data-handle]')].map((x) => x.dataset.handle).concat(prod);
    const clash = (a) => a.dataset.peca && hs.some((x) => x.includes(a.dataset.peca));
    const out = queue.filter((a) => !skip.includes(a) && !clash(a)).slice(0, n);
    for (const a of queue) if (out.length < n && !skip.includes(a) && !out.includes(a)) out.push(a);
    return out;
  };

  /* lugares usados pela grade, simulando o auto-placement (azulejos com span 2 ou linha inteira) */
  const missing = (items, cols) => {
    let pos = 0;
    for (const li of items) {
      const cs = getComputedStyle(li);
      let span = 1;
      if (cs.gridColumnEnd === '-1') span = cols;
      else {
        const m = /span (\d+)/.exec(cs.gridColumnStart + ' ' + cs.gridColumnEnd);
        if (m) span = Math.min(cols, +m[1]);
      }
      if ((pos % cols) + span > cols) pos += cols - (pos % cols);
      pos += span;
    }
    return (cols - (pos % cols)) % cols;
  };

  const fillGrid = async (grid) => {
    const old = grid.querySelector(':scope > [data-sv-fill]');
    const items = [...grid.children].filter((li) => !li.hasAttribute('data-sv-fill'));
    const cs = getComputedStyle(grid);
    const cols = cs.display === 'none' ? 0 : cs.gridTemplateColumns.split(' ').filter(Boolean).length;
    const host = grid.closest('sv-collection') || grid.parentElement;
    const rest = cols > 1 && items.length && !host.querySelector('[data-sv-more]') ? missing(items, cols) : 0;
    const card = rest && pick(grid, [], 1)[0];
    const key = card ? card.dataset.k + ':' + rest + ':' + cs.columnGap : '';
    if (!key) return old?.remove();
    if (old && old.dataset.svFill === key && grid.lastElementChild === old) return;
    await ready();
    old?.remove();
    grid.querySelector(':scope > [data-sv-fill]')?.remove();
    const li = make('li', 'sv-fill-li' + (rest > 1 ? ' sv-fill-li--wide' : ''), key, card);
    li.style.gridColumn = 'span ' + rest;
    li.style.setProperty('--n', rest);
    li.style.setProperty('--g', cs.columnGap);
    grid.appendChild(li);
  };

  const fillRow = async (row) => {
    const olds = [...row.querySelectorAll(':scope > [data-sv-fill]')];
    const n = row.children.length - olds.length;
    const want = n ? Math.max(0, (desk.matches ? 4 : 3) - n) : 0;
    // o card que a grade da coleção usa (ou usaria) fica reservado para ela
    const grid = document.querySelector('[data-sv-grid]');
    const cards = want ? pick(row, grid ? pick(grid, [], 1) : [], want) : [];
    const key = cards.map((a) => a.dataset.k).join(',');
    if (olds.map((x) => x.dataset.svFill).join(',') === key && (!want || row.lastElementChild === olds[olds.length - 1])) return;
    if (want) await ready();
    olds.forEach((x) => x.remove());
    cards.forEach((a) => row.appendChild(make('div', 'sv-fill-cell', a.dataset.k, a)));
  };

  const run = () => {
    document.querySelectorAll('[data-sv-grid]').forEach(fillGrid);
    document.querySelectorAll('[data-sv-more="rv"] [data-sv-more-row]').forEach(fillRow);
  };
  let t;
  const later = () => {
    clearTimeout(t);
    t = setTimeout(run, 60);
  };

  // grade trocada (filtro, ordenação, Carregar mais), densidade (data-d/data-m) e Peças|Looks (classe do host)
  // (observe() de novo no mesmo nó troca as opções, por isso dois observadores)
  const deep = new MutationObserver(later);
  const host = new MutationObserver(later);
  document.querySelectorAll('sv-collection, sv-more').forEach((el) => {
    deep.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-d', 'data-m'] });
    host.observe(el, { attributes: true, attributeFilter: ['class'] });
  });
  addEventListener('resize', later, { passive: true });
  run();
})();
